/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Capacitor } from '@capacitor/core';

let onClickDeveloper = () => null;

// This only runs on localhost for web
if (
  !Capacitor.isNativePlatform() &&
  process.env.REACT_APP_AZURE_B2C_LOGIN_REDIRECT_URI === 'http://localhost:3000/'
) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  onClickDeveloper = require('./DebugAuth.tsx').default;
}
// This runs on Capacitor with this check:
else if (
  Capacitor.isNativePlatform() &&
  (process.env.REACT_APP_PACKAGE_NAME_ANDROID === 'nz.co.farmlands.farmlandspro.dev' ||
    process.env.REACT_APP_PACKAGE_NAME_ANDROID === 'nz.co.farmlands.farmlandspro.test') &&
  Capacitor.DEBUG
) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  onClickDeveloper = require('./DebugAssignAuth.tsx').default;
}

export const isIosSimulatorLocalhost = Capacitor.getPlatform() === 'ios' && Capacitor.DEBUG;

export const isAndroidSimulatorLocalhost = Capacitor.getPlatform() === 'android' && Capacitor.DEBUG;

export default onClickDeveloper;
